import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Partner } from './partner-entity';


export class Visit extends BaseEntity {

    visitCode           : string;
    startTime           : Date  ;
    endTime             : Date  ;
    itineraryLineNumber : number;
    plannedRank         : number;
    actualRank          : number;
    partner             : Partner;
    visitResultCode     : string;

    collectedAmount     : number;
    positionMismatch	: boolean; 
    mslNonCompliantVisit: boolean; 
    visitResultName     : string;

    //targetedAmount      : number ;
    achievedAmount      : number ;
    //targetedVolume      : number ;
    achievedVolume      : number ;

  constructor() {
    super();

  }
}
